import React from "react";
import PropTypes from "prop-types";
import { Root } from "./RemoveButton.styles";

export const RemoveButton = ({ label = "", ...rest }) => (
  <Root {...rest} role="button" aria-label={`Remove ${label}`}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#495057"
      aria-labelledby="Times"
    >
      <title id="Times">Remove {label}</title>
      <path d="M14.274 12l3.412-3.411a1.072 1.072 0 000-1.517l-.758-.758a1.072 1.072 0 00-1.517 0L12 9.725 8.589 6.314a1.072 1.072 0 00-1.517 0l-.758.758a1.072 1.072 0 000 1.517L9.725 12l-3.411 3.412a1.072 1.072 0 000 1.516l.758.758a1.072 1.072 0 001.517 0L12 14.274l3.412 3.412a1.072 1.072 0 001.516 0l.758-.758a1.072 1.072 0 000-1.517L14.274 12z"></path>
    </svg>
  </Root>
);

RemoveButton.propTypes = {
  label: PropTypes.string,
};
